module.exports = __webpack_public_path__ + "img/qitachanping.3216366f.png";